import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { ZSHOP_PICTURE } from '@eliadmin/core/src/components/product/detail/product-images';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useProformQuery } from '@eliadmin/core/src/stores/configurator-store';
import type { ProductDetailsWithSlug } from '@eliadmin/core/src/stores/variant-store';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { useState } from 'react';

export const ProductTabCuts = () => {
  const { t } = useTranslations();

  const product = useVariantsStore(s => s.product) as ProductDetailsWithSlug & {
    metadata: {
      smako_tech_info: {
        custom_title: string;
        url: string;
        id: number;
        name: string;
      }[];
    };
  };

  const images = [
    ...(product.images ?? []),
    ...(product.variants ?? []).flatMap(variant => variant.images ?? []),
  ]
    .filter(Boolean)
    .filter((image: any) => image?.metadata?.type === ZSHOP_PICTURE.REZ);

  const [imagesSorted, setImagesSorted] = useState(images);

  const { setIsOpen, isOpen } = useDisclosure();
  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && images.length > 0 && index >= 0 && index < images.length) {
      const newImages = [images[index], ...images.slice(index + 1), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };
  return (
    <Container className={cn('flex flex-col px-2', 'ea-product-detail-tab-question-form')}>
      <h2 className="mb-4">{t('text1045')}</h2>
      <LightboxComponent
        images={imagesSorted}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        zoom={{ maxZoomPixelRatio: 10 }}
      />
      <div className="mt-4 grid grid-cols-12 gap-4">
        {images?.map((image: any, i) => (
          <div key={i} className="col-span-12 mb-4">
            <Image
              alt={resolveImageAlt(image, 'image')}
              src={image?.url}
              width="0"
              height="0"
              sizes="100vw"
              className="w-full rounded-lg object-contain"
              onClick={handleOpenGallery(images, i)}
            />
          </div>
        ))}
      </div>
    </Container>
  );
};
